/* Gift card value pills (snippets/custom-gift-card-form.liquid) and the
   ideas grid's "<value> gift card" buttons (sections/custom-gift-card-ideas.liquid).
   The pills are radios named "id", so the form already posts the picked
   variant; this only keeps the rest of the page in step:
   - the product page's ?variant= URL (not on the guide promo),
   - Dawn's recipient form, which tracks the variant through pub/sub,
   - the ideas grid, whose button for the picked value shows as chosen.
   docs/Gift Cards.md */
(() => {
  const announce = (form, variantId) => {
    const productForm = form.closest('product-form');
    const sectionId = productForm && productForm.dataset.sectionId;
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && sectionId) {
      publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId, variant: { id: Number(variantId) } } });
    }
    document.querySelectorAll('.gift-card-ideas__pick').forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.variantId === String(variantId) ? 'true' : 'false');
    });
  };

  const sync = (radio) => {
    const form = radio.form;
    if (form.closest('[data-gift-card-url]')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url.toString());
    }
    announce(form, radio.value);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('.gift-card-form__radio')) sync(event.target);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.gift-card-ideas__pick');
    if (!button) return;
    const radio = document.querySelector(`.gift-card-form__radio[value="${button.dataset.variantId}"]`);
    if (!radio || radio.disabled) return;
    radio.checked = true;
    sync(radio);
    const fieldset = radio.closest('.gift-card-form__values');
    fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    radio.focus({ preventScroll: true });
  });

  // The recipient form starts on the first variant; tell it about a
  // preselected one once every deferred script (pub/sub, recipient-form.js)
  // has run, which DOMContentLoaded waits for.
  const start = () => {
    document.querySelectorAll('.gift-card-form__radio:checked').forEach((radio) => announce(radio.form, radio.value));
  };
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
